import React, { Fragment } from "react";
import { useDispatch } from "react-redux";
import { FormattedMessage } from "react-intl";

import { Icon } from "../../icon/Icon";
import { openRenameModal } from "../devices.actions";
import { LazyLoadDropdownItem } from "@sportal/cdk/dropdown/LazyLoadDropdownItem";
import { DeviceActionsModalItem } from "../DeviceActionsDialog";

export const useRenameDeviceMenuItem = (device) => {
  const dispatch = useDispatch();

  return {
    id: "rename",
    content: (
      <Fragment>
        <Icon icon="fa-regular fa-pencil" />
        <span>
          <FormattedMessage id="rename" />
        </span>
      </Fragment>
    ),
    action: () => dispatch(openRenameModal(device)),
  };
};

export const RenameDeviceDropdownItem = ({ device, ...props }) => {
  const { id, content, action } = useRenameDeviceMenuItem(device);

  return (
    <LazyLoadDropdownItem id={id} action={action} {...props}>
      {content}
    </LazyLoadDropdownItem>
  );
};

export const RenameDeviceModalItem = ({ device }) => {
  const { id, content, action } = useRenameDeviceMenuItem(device);

  return (
    <DeviceActionsModalItem id={id} action={action}>
      {content}
    </DeviceActionsModalItem>
  );
};
